import { CapacitorUpdater } from '@capgo/capacitor-updater';

/**
 * Capgo Live Updates: call notifyAppReady so a bad bundle can roll back.
 * Channel is set at build/upload time (staging vs production), not here.
 */
export async function initLiveUpdates() {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (!Capacitor.isNativePlatform()) return;
    await CapacitorUpdater.notifyAppReady();
  } catch (err) {
    // Web or updater not configured — ignore
    console.debug('Live updates init skipped', err?.message || err);
  }
}
